export default __webpack_public_path__ + "static/media/placeholder_store03-es-mobile.d642f8bc.png";